import { Profile } from "./profile";

export type ProfileFilterCriteria = {
  ageMin: number | null;
  ageMax: number | null;
  gender: "any" | "man" | "woman" | "non-binary" | "other" | "prefer-not";
  eyeColor: "any" | "brown" | "blue" | "green" | "hazel" | "other";
  heightBand: "any" | "short" | "medium" | "tall";
  pets: "any" | "dogs" | "cats" | "both" | "other" | "none";
};

export const DEFAULT_PROFILE_FILTER: ProfileFilterCriteria = {
  ageMin: 32,
  ageMax: 32,
  gender: "any",
  eyeColor: "any",
  heightBand: "any",
  pets: "any"
};

export function isDefaultProfileFilter(f: ProfileFilterCriteria): boolean {
  return (
    f.ageMin === 32 &&
    f.ageMax === 32 &&
    f.gender === "any" &&
    f.eyeColor === "any" &&
    f.heightBand === "any" &&
    f.pets === "any"
  );
}

export function profileMatchesFilters(p: Profile, f: ProfileFilterCriteria): boolean {
  if (f.ageMin !== null && p.age < f.ageMin) return false;
  if (f.ageMax !== null && p.age > f.ageMax) return false;
  if (f.gender !== "any" && p.gender !== f.gender) return false;
  if (f.eyeColor !== "any" && p.eyeColor !== f.eyeColor) return false;
  if (f.heightBand !== "any" && p.heightBand !== f.heightBand) return false;
  if (f.pets !== "any" && p.pets !== f.pets) return false;
  return true;
}
